$( function() {
  var $body = $('body');
  var ua = navigator.userAgent.toLowerCase();

  function layoutSwitcher() {
    var $switcher = $('.js-switcher');
    $switcher.on('click', function() {
      var layout = $(this).attr('data-layout');
      if ( layout == 'list' ) {
        $('#ajax-container').addClass('is-listed');
      } else {
        $('#ajax-container').removeClass('is-listed');
      }
      $switcher.removeClass('is-active');
      $(this).addClass('is-active');
    });
  }

  function updateMenu($navItem) {
    $navItem.removeClass('is-active');
    $('.sf-field-category').find('.sf-input-checkbox:checked').each(function() {
      var selected = $(this).val();

      $navItem.filter('.'+selected).addClass('is-active');
    });
  }

  function sfSetPadding() {
    $('.sf-input-checkbox').each(function(i, el) {
      var children = $(el).nextAll('.children');
      var parent = $(el).parent('li');

      if( children.length ) {
        console.log(children.height())
        if ( parent.hasClass('sf-option-active') ) {
          parent.css('padding-bottom', children.height());
          children.addClass('is-visible');
        } else {
          parent.css('padding-bottom', 0);
          children.removeClass('is-visible');
        }
      }
    });
  }

  function sfSetClass() {
    var input = $('.sf-item-24 input');
    var taxonomy = $('.sf-field-taxonomy-project_category');
    var isChecked = input.prop('checked');
    if ( isChecked ) {
      taxonomy.addClass('is-visible');
    } else {
      taxonomy.removeClass('is-visible');
    }

  }

  function sfAddEvent() {
    $navItem = $('#nav').find('.l-header__nav_item');

    updateMenu($navItem);
    sfSetClass();
    // sfSetPadding();

    $(document).on("sf:ajaxstart", ".searchandfilter", function(){
      updateMenu($navItem);
      sfSetClass();
    });
    $(document).on("sf:ajaxfinish", ".searchandfilter", function(){
      sfSetClass();
      // sfSetPadding();
    });

    $('.js-filterDetail').on('click', function(event) {
      $('.js-filter').toggleClass('is-detail-open');
      return false;
    });

  }


  // fire when DOM is ready
  $(function() {
    layoutSwitcher();
    sfAddEvent();
  });

});
